import { Box, Stack } from '@mui/material';
import Logo from 'src/components/logo';
import useNavData from 'src/hooks/useNavData';
// config
import { NAV } from 'src/static/constants';

// components
import { NavSectionMini } from '../../../components/nav-section';
// utils
import { hideScrollbarX } from '../../../utils/cssStyles';

import NavAccount from './NavAccount';
import NavToggleButton from './NavToggleButton';

export default function NavMini() {
  const navData = useNavData();
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini data={navData} />
        <Box sx={{ flexGrow: 1, minHeight: 100 }} />
        <NavAccount isMini={true} />
      </Stack>
    </Box>
  );
}
